import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Text, List, ListItem, Typography } from '@blueprint/ui';
import FileSaver from 'file-saver';
import pnFile from './privacyNotice.pdf';
import pnEsFile from './spainPrivacyNoticeEn.pdf';
import pnEnFile from './spainPrivacyNoticeEs.pdf';

const PrivacyNoticePlaceholder = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const PrivacyNotice = () => {
    const { t } = useTranslation();
    const [textDecoration, setTextDecoration] = useState('none');

    const saveFile = () => {
        FileSaver.saveAs(pnFile, 'HSBC Bank and HSBC UK Privacy notice.pdf');
    };
    const saveEnFile = () => {
        FileSaver.saveAs(pnEnFile, 'HSBC Continental Europe Sucursal en España en.pdf');
    };
    const saveEsFile = () => {
        FileSaver.saveAs(pnEsFile, 'HSBC Continental Europe Sucursal en España es.pdf');
    };
    return (
        <PrivacyNoticePlaceholder>
            <Box>
                <Box>
                    <Box borderLeft='3px solid red' margin='0 0 1vw 0' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('privacyNotice.privacyNoticeBsm')}
                        </Typography>
                    </Box>
                    <List listStyleType='decimal'>
                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.thePrivacyNoticeOverviewApplies')}
                                </Text>
                                <List listStyleType='disc'>
                                    <ListItem>
                                        <Text variant='body1'>{t('privacyNotice.whichFullPrivacy')}</Text>
                                    </ListItem>
                                    <ListItem>
                                        <Text variant='body1'>{t('privacyNotice.theInformationWeCollect')}</Text>
                                    </ListItem>
                                    <ListItem>
                                        <Text variant='body1'>{t('privacyNotice.howWeUse')}</Text>
                                    </ListItem>
                                    <ListItem>
                                        <Text variant='body1'>{t('privacyNotice.whoWeMight')}</Text>
                                    </ListItem>
                                </List>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.beforeWeBegin')}
                                </Text>
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.inThisPrivacyNoticeOverview')}</Text>
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.beneficiaryOrYou')}</Text>
                            </Box>
                        </ListItem>

                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.whichFullPrivacyNotice')}
                                </Text>
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.theEmailYouReceive')}</Text>
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankPlc')} &nbsp;</Text>
                                {/* <a href={pnFile} download> */}
                                <Text
                                    variant='body1'
                                    style={{ color: '#23527c', textDecoration: 'underline', cursor: 'pointer' }}
                                    onHover={() => {
                                        setTextDecoration('underline');
                                    }}
                                    onClick={() => {
                                        saveFile();
                                    }}
                                >
                                    {t('privacyNotice.hsbcPdf')}
                                </Text>
                                {/* </a> */}
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankUsa')} &nbsp;</Text>
                                <a
                                    href={t('privacyNotice.hsbcLink1')}
                                    target='_blank'
                                    style={{ color: '#23527c', textDecoration: 'underline' }}
                                    aria-label={t('privacyNotice.hsbcLink1')+" Opens in a new window"}
                                >
                                    <Text variant='body1' style={{ color: '#23527c' }} >
                                        {t('privacyNotice.hsbcLink1')} ({t( 'footer.new_window')})
                                    </Text>
                                </a>
                            </Box>
                            <Box margin='0px 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankIreland')} &nbsp;</Text>
                                <a
                                    href={t('privacyNotice.hsbcLink2')}
                                    target='_blank'
                                    style={{ color: '#23527c', textDecoration: 'underline' }}
                                    aria-label={t('privacyNotice.hsbcLink2')+" Opens in a new window"}
                                >
                                    <Text variant='body1' style={{ color: '#23527c' }}>
                                        {t('privacyNotice.hsbcLink2')} ({t( 'footer.new_window')})
                                    </Text>
                                </a>
                            </Box>
                            <Box margin='0px 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankNetherlands')} &nbsp;</Text>
                                <a
                                    href={t('privacyNotice.hsbcLink3')}
                                    target='_blank'
                                    style={{ color: '#23527c', textDecoration: 'underline' }}
                                    aria-label={t('privacyNotice.hsbcLink3')+" Opens in a new window"}
                                >
                                    <Text variant='body1' style={{ color: '#23527c' }}>
                                        {t('privacyNotice.hsbcLink3')} ({t( 'footer.new_window')})
                                    </Text>
                                </a>
                            </Box>
                            <Box margin='0px 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankMiddleEast')} &nbsp;</Text>
                                <a
                                    href={t('privacyNotice.hsbcLink4')}
                                    target='_blank'
                                    style={{ color: '#23527c', textDecoration: 'underline' }}
                                    aria-label={t('privacyNotice.hsbcLink4')+" Opens in a new window"}
                                >
                                    <Text variant='body1' style={{ color: '#23527c' }}>
                                        {t('privacyNotice.hsbcLink4')} ({t( 'footer.new_window')})
                                    </Text>
                                </a>
                            </Box>
                            <Box margin='0px 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankSpainEn')} &nbsp;</Text>
                                <Text
                                    variant='body1'
                                    style={{ color: '#23527c', textDecoration: 'underline', cursor: 'pointer' }}
                                    onHover={() => {
                                        setTextDecoration('underline');
                                    }}
                                    onClick={() => {
                                        saveEnFile();
                                    }}
                                >
                                    {t('privacyNotice.hsbcPdfEn')}
                                </Text>
                            </Box>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.hsbcBankSpainEs')} &nbsp;</Text>
                                <Text
                                    variant='body1'
                                    style={{ color: '#23527c', textDecoration: 'underline', cursor: 'pointer' }}
                                    onHover={() => {
                                        setTextDecoration('underline');
                                    }}
                                    onClick={() => {
                                        saveEsFile();
                                    }}
                                >
                                    {t('privacyNotice.hsbcPdfEs')}
                                </Text>
                            </Box>

                        </ListItem>
                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.informationWeCollect')}
                                </Text>
                            </Box>

                            <Box margin='0 0 5px 0'>
                                <Text variant='body1'>{t('privacyNotice.theInformationWeCollectFromYouIsRequired')}</Text>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.howWeWillUse')}
                                </Text>
                            </Box>

                            <Box margin='0 0 0px 0'>
                                <Text variant='body1'>{t('privacyNotice.weWillUseYourInformationForExample')}</Text>
                            </Box>
                            <List listStyleType='disc'>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.toNotifyYouByEmail')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.toProvideYouWithAccess')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.forTheProvisionOfOur')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.toPreventOrDetect')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.forProductAndService')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 10px 0'>
                                        <Text variant='body1'>{t('privacyNotice.toProtectOurLegal')}</Text>
                                    </Box>
                                </ListItem>
                            </List>
                            <Box margin='0 0 0px 0'>
                                <Text variant='body1'>{t('privacyNotice.dependingOnHsbcGroupCompany')}</Text>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box margin='0 0 5px 0'>
                                <Text variant='body1' fontWeight='bold'>
                                    {t('privacyNotice.whoWeMightShareYourInformationWith')}
                                </Text>
                            </Box>

                            <Box margin='0 0 0px 0'>
                                <Text variant='body1'>{t('privacyNotice.weMayShareYourInformationWithOthers')}</Text>
                            </Box>
                            <List listStyleType='disc'>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.needToShareYourInformation')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.haveAPublicOrLegal')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 0px 0'>
                                        <Text variant='body1'>{t('privacyNotice.inConnectionWithRegulatoryReporting')}</Text>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box margin='0 0 10px 0'>
                                        <Text variant='body1'>{t('privacyNotice.inOrderToManageRisk')}</Text>
                                    </Box>
                                </ListItem>
                            </List>
                            <Box margin='0 0 0px 0'>
                                <Text variant='body1'>{t('privacyNotice.furtherInformationOnHowWeWill')}</Text>
                            </Box>
                        </ListItem>
                    </List>
                </Box>
            </Box>
        </PrivacyNoticePlaceholder>
    );
};

export default PrivacyNotice;
